// src/adm/AdmLayout.jsx
import { Outlet } from "react-router-dom";
import { useLayoutEffect } from "react";

export default function AdmLayout() {
  useLayoutEffect(() => {
    const prevLang = document.documentElement.lang;
    if (!prevLang) document.documentElement.lang = "ko";

    document.body.classList.add("adm");

    return () => {
      document.documentElement.lang = prevLang || "ko";
      document.body.classList.remove("adm");  
    };
  }, []);

  return (
    <div className="adm-container">
      <Outlet />
    </div>
  );
}
